export const QUICK_LINKS_DIMENSIONS_BLACK_LIST = [
  'last_attributed_touch_data_plus_pam_enabled',
  'last_attributed_touch_data_plus_aggregate_measurement',
];
